import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=3bf94c6a&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"
import style0 from "./datatable.vue?vue&type=style&index=0&id=3bf94c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf94c6a",
  null
  
)

export default component.exports